<template>
    <div  aria-hidden="true" aria-labelledby="modal-reject-transaction" class="modal fade" id="modal-reject-transaction"  role="dialog" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="modal-title-default">{{ $t('messages.reject_item')}}</h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <form role="form" @submit.prevent="reject">
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div v-if="serverError" class="alert alert-danger">
                    <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                  </div>
                </div>
              </div>
              <div class="row">
                <select-withdraw-reject-reasons v-model="reason" :options="{ id: 'reason', error: fieldErrors.reason, containerClass: 'col-12' }"/>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-danger btn-sm ml-auto" data-dismiss="modal" type="button">
                {{ $t('labels.close') }}
              </button>
              <button type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                {{ $t('labels.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
    import { WITHDRAW_REQUESTS_REJECT as CRUD_ACTION_REJECT} from 'actions/withdraw_requests';
    export default {
        name: "WithdrawRequestActionsModalsReject",
        props: {
            activeRejectParams:{
                type:Object,
                default:function(){
                  return {};
                }
            },
            successCallback: {
                type: Function,
                default: () => { }
            },
        },
        data(){
            return {
                serverError: '',
                fieldErrors: {},
                loading: false,
                reason:"",
                activeId:null,
                activeIndex:null,
            }
        },
        watch:{
          activeRejectParams:function(newVal, oldVal) {
            this.serverError=null;
            this.reason="";
            this.activeId=newVal.activeId;
            this.activeIndex=newVal.activeIndex;
          },
        },
        methods:{
            reject(){
                this.loading = true
                this.$store.dispatch(CRUD_ACTION_REJECT, {
                    id:this.activeId,
                    data: {
                        ...this.prepareRequestData()
                    },
                })
                .then(() => {
                    document.querySelector('#modal-reject-transaction [data-dismiss]').click();
                    this.loading = false;
                    this.reason="";
                    this.fieldErrors={};
                    this.serverError='';
                    this.successCallback();
                    swal({
                        icon: 'success',
                        text: this.$i18n.t("messages.reject_successfully"),
                        buttons:false,
                        timer: 5000
                    });
                })
                .catch(error => {
                    this.loading = false
                    this.fieldErrors={};
                    this.serverError='';

                    if(error.response){
                        let responseData=error.response.data;

                        if(responseData.errors){
                            this.fieldErrors=responseData.errors;
                        }else{
                            this.serverError = 'Invalid Request.'
                        }
                    }else{
                        this.serverError = this.$i18n.t("messages.no_internet_connection");
                    }

                    if(this.fieldErrors.error){
                        this.serverError = this.fieldErrors.error;
                    }
                })
            },
            prepareRequestData(){
                return {
                    reason: this.sanitizeField('reason'),
                }
            },
        }
    }
</script>

<style scoped>

</style>
